import React from "react"
import { graphql, Link } from "gatsby"

import { Layout } from "../../components/common"
import { MetaData } from "../../components/common/meta"

const Country = ({ data, location }) => {
    const { country } = data.country

    return (
        <>
            <MetaData 
                location={location} 
                title={`${country} Go Karting Cities, and Tracks`}
                description={`Find go karting tracks near you. Motorsport tracks and events in ${country}.`}
                />
            <Layout>
                <h1>Popular Cities in {country}</h1>
                <ul>
                    {data.cities.edges.map(({ node }) => (
                        <li>
                            <a href={`/${node.filename}`}>{node.city}</a>
                        </li>
                    ))}
                </ul>
            </Layout>
        </>
    )
}
export default Country

// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
    query CountryQuery($country: String!) {
        country: worldcitiesFilteredCsv(country: { eq: $country }) {
            filename
            city
            lat
            lng
            city_ascii
            country
        }
        cities: allWorldcitiesFilteredCsv(
            filter: { country: { eq: $country } }
        ) {
            edges {
                node {
                    filename
                    city
                }
            }
        }
    }
`
